import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const TextDecoration = z.enum(["None", "Underline", "Strikethrough"]);
export const TextDecorationValue = TextDecoration;
export const TextDecorationTokenData = tokenAliasOrValue(TextDecorationValue);

export type TextDecoration = z.infer<typeof TextDecoration>;
export type TextDecorationValue = z.infer<typeof TextDecorationValue>;
export type TextDecorationTokenData = z.infer<typeof TextDecorationTokenData>;
